import debounce from "lodash.debounce";
export default {
  convertSeconds(totalSeconds) {
    const numberSeconds = Number(totalSeconds);

    if (isNaN(numberSeconds) || numberSeconds < 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    const hours = Math.floor(numberSeconds / 3600);
    const minutes = Math.floor((numberSeconds % 3600) / 60);
    const seconds = numberSeconds % 60;

    return { hours, minutes, seconds };
  },
  convertSecondsToDecimalHours(totalSeconds) {
    const numberSeconds = Number(totalSeconds);

    if (isNaN(numberSeconds) || numberSeconds < 0) {
      return 0;
    }

    const decimalHours = numberSeconds / 3600;
    return decimalHours;
  },
  convertToDecimalHours(hours, minutes, seconds) {
    const decimalHours =
      parseInt(hours) + parseInt(minutes) / 60 + parseInt(seconds) / 3600;
    return decimalHours;
  },

  formatPhoneNumber(phoneNumber) {
    if (phoneNumber && phoneNumber.length === 10) {
      return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
        3,
        6
      )}-${phoneNumber.substring(6)}`;
    }
    return phoneNumber;
  },

  formatDateToMMDDYYYY(dateString) {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${month}-${day}-${year}`;
  },

  formatDateToDDMMMYYYY(dateString) {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);

    if (isNaN(date)) {
      return "";
    }

    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  },
  
  formatDateNoTimezone(dateString) {
    if (!dateString) {
      return "";
    }
  

    const date = new Date(dateString + "T00:00:00Z");
  
    if (isNaN(date)) {
      return "";
    }
  
    const day = date.getUTCDate();
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
  },
  

  createDebouncedFetch(store, type, searchType, id_project = null) {
    const fetch = async (query) => {
      //esto es para tasks
      let type4search = "";
      if (type == "tasks") {
        type4search =
          searchType.value == "Active"
            ? ["In progress", "Not Started", "Missed"]
            : ["Complete"];
      } else if (type == "users") {
        type4search = searchType.value == "Employees" ? 2 : 3;
      }

      try {
        await store.dispatch("fetchTable", {
          page: 1,
          limit: 10,
          type: type,
          search: query.target.value,
          searchType: type4search != "" ? type4search : searchType.value,
          id_project: id_project,
        });
      } catch (error) {
        console.error("Error fetching :" + type, error);
      }
    };

    return debounce(fetch, 300);
  },

  capitalize(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  truncatedFileName(fileName) {
    const maxLength = 17;
    return fileName.length > maxLength
      ? fileName.substring(0, maxLength) + "..."
      : fileName;
  },

  // Etiqueta legible de la recurrencia de un proyecto.
  // Originales: "Weekly", "Every 2 weeks". Copias: "Cycle #N". Sin recurrencia: "".
  projectRecurrenceLabel(project) {
    if (!project) return "";
    const units = {
      daily: ["Daily", "day"],
      weekly: ["Weekly", "week"],
      monthly: ["Monthly", "month"],
      yearly: ["Yearly", "year"],
    };
    if (project.recurrence) {
      const def = units[project.recurrence];
      if (!def) return project.recurrence;
      const n = Number(project.recurrence_interval) || 1;
      return n === 1 ? def[0] : `Every ${n} ${def[1]}s`;
    }
    if (project.id_parent_project) {
      return project.recurrence_cycle
        ? `Cycle #${project.recurrence_cycle}`
        : "Recurring copy";
    }
    return "";
  },

  // Due date legible: { date: "Mar 5, 2026", hint: "in 3 days" | "2 days overdue" | "Today", tone }
  // tone: "overdue" | "soon" | "normal" | "none". Usa UTC como formatDateToMMDDYYYY.
  dueDateInfo(dateString, status) {
    if (!dateString) return { date: "No due date", hint: "", tone: "none" };
    const date = new Date(dateString);
    if (isNaN(date)) return { date: "No due date", hint: "", tone: "none" };

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formatted = `${monthNames[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;

    if (status === "Completed") return { date: formatted, hint: "", tone: "normal" };

    const now = new Date();
    const todayUTC = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const dueUTC = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    const days = Math.round((dueUTC - todayUTC) / 86400000);

    if (days < 0) {
      const d = -days;
      return { date: formatted, hint: `${d} day${d === 1 ? "" : "s"} overdue`, tone: "overdue" };
    }
    if (days === 0) return { date: formatted, hint: "Today", tone: "soon" };
    if (days === 1) return { date: formatted, hint: "Tomorrow", tone: "soon" };
    return {
      date: formatted,
      hint: `in ${days} days`,
      tone: days <= 7 ? "soon" : "normal",
    };
  },

  // Mismo cálculo que DescriptionComponent (tareas completadas / totales)
  projectProgress(project) {
    if (!project) return 0;
    const completed = Number(project.total_completed_tasks) || 0;
    const total = Number(project.total_tasks) || 1;
    return Math.min(100, Math.round((completed / total) * 100));
  },
};


